import { render, staticRenderFns } from "./DomainOppositionResponsibleForm.vue?vue&type=template&id=5b3b7522&"
import script from "./DomainOppositionResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports